import { isNil } from 'ramda';
import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { MediaData } from '~admin/model/media-data';

interface Props {
  media: MediaData;
}

export const MediaPreviewVideo: React.FunctionComponent<Props> = ({ media }) => {
  const videoRef = useRef<HTMLVideoElement>(undefined);
  const { url } = media;

  useEffect((): void => {
    if (!isNil(videoRef.current)) {
      // Improves video preview experience by showing 1 sec frame
      // some videos start with a black frame at the very beginning
      videoRef.current.currentTime = 1;
    }
  }, [videoRef.current]);

  return (
    <Video ref={videoRef}>
      <source src={url} />
    </Video>
  );
};

const Video = styled.video`
  width: 100%;
  height: 100%;
`;



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media/media-preview/media-preview-video.component.tsx